import { Box, Container, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { ContentWrapper } from "../components/layout/ContentWrapper";
import { BottomActionBar } from "../components/utils/BottomActionBar";
import { ExternalLink } from "../components/utils/ExternalLink";
import SocialButton from "../components/utils/SocialButton";
import GoogleMap from "../components/view/GoogleMap";
import { routes } from "../constants/routes";
import { ContentfulContext } from "../context/ContentfulContext";
import { Asset, Contact, Footer } from "../models/schema";
import { colors } from "../theme/colors";

const ContactPage = () => {
  const { content } = useContext(ContentfulContext);
  const contact = content?.contact as Contact;
  const footer = content?.footer as Footer;
  const {
    addressMapUrl,
    bottomBannerLabel,
    bottomBannerAction,
    title,
    mediaContactLabel,
    mediaContactEmail,
    mediaContactPhone
  } = contact;

  const convertLabel = (label?: string) => label?.toLocaleUpperCase();

  return (
    <>
      <ContentWrapper title={title as string} sx={{ pb: 10 }}>
        <Container sx={{ p: { xs: 0 } }}>
          <Grid container spacing={5}>
            {/* PHONE AND EMAIL DISABLED */}
            {/* <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "center" }
              }}>
              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                <Typography mb={3}>{convertLabel(contactsLabel as string)}</Typography>
                {email && (
                  <Box
                    sx={{
                      display: "flex"
                    }}>
                    <Typography>{emailLabel}:</Typography>
                    <ExternalLink
                      href={`mailto:${email as string}`}
                      sx={{ ml: 2, color: colors.black }}>
                      <strong>{email as string}</strong>
                    </ExternalLink>
                  </Box>
                )}
                {phone && (
                  <Box
                    sx={{
                      display: "flex"
                    }}>
                    <Typography>{phoneLabel}:</Typography>
                    <ExternalLink
                      href={`tel:${phone as string}`}
                      sx={{ ml: 5, color: colors.black }}>
                      <strong>{phone as string}</strong>
                    </ExternalLink>
                  </Box>
                )}
              </Box>
            </Grid> */}
            {/* RESIDENCE ADDRESS DISABLED */}
            {/* <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "center" }
              }}>
              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                <Typography mb={3}>{convertLabel(addressLabel as string)}</Typography>
                <RenderContent content={address?.json} />
              </Box>
            </Grid> */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "center" }
              }}>
              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                <Typography mb={3}>{convertLabel(mediaContactLabel as string)}</Typography>
                {mediaContactPhone && (
                  <Box>
                    <ExternalLink
                      href={`tel:${mediaContactPhone as string}`}
                      sx={{ color: colors.black }}>
                      <strong>{mediaContactPhone as string}</strong>
                    </ExternalLink>
                  </Box>
                )}
                {mediaContactEmail && (
                  <Box>
                    <ExternalLink
                      href={`mailto:${mediaContactEmail as string}`}
                      sx={{ color: colors.black }}>
                      <strong>{mediaContactEmail as string}</strong>
                    </ExternalLink>
                  </Box>
                )}
              </Box>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                justifyContent: { xs: "flex-start", md: "center" }
              }}>
              <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                <Typography mb={3}>{convertLabel(footer.followUs as string)}</Typography>
                <Box
                  sx={{
                    display: "flex",
                    gap: 2
                  }}>
                  {footer.socialConnectionsCollection?.items.map((socialConnection) => (
                    <SocialButton
                      grayScale
                      key={socialConnection?.title}
                      link={socialConnection?.url as string}
                      logo={socialConnection?.logo as Asset}
                    />
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </ContentWrapper>
      <GoogleMap url={addressMapUrl as string} />
      <BottomActionBar
        actionLabel={bottomBannerAction as string}
        title={bottomBannerLabel as string}
        route={routes.solutions}
      />
    </>
  );
};

export default ContactPage;
